export const newsList = [
  {
    id: "news-1001",
    title: "深夜排污疑云：三县交界河道水质异常调查",
    summary:
      "连续多日凌晨，交界河道出现刺鼻气味与乳白色泡沫。记者历时两周走访，试图还原排放源头与监管空档。",
    category: "breaking",
    topics: ["t1", "t3", "t4"],
    source: "911爆料调查组",
    author: "调查组",
    publishedAt: "2026-10-14 08:20",
    image:
      "https://readdy.ai/api/search-image?query=Dark%20moody%20investigative%20news%20scene%20of%20an%20industrial%20river%20at%20night%2C%20faint%20deep%20red%20ambient%20light%20on%20murky%20water%2C%20layered%20fog%20and%20long%20exposure%20smoke%2C%20cinematic%20editorial%20photography%2C%20charcoal%20tones%2C%20strong%20contrast%2C%20stylized%20not%20photoreal%2C%20no%20text&width=1200&height=800&seq=911-news-1001&orientation=landscape",
    exclusive: false,
    isFocus: true,
    views: 128430,
    content: [
      {
        type: "paragraph",
        text: "入秋以来，位于三县交界的清河下游连续出现水质异常：水面浮起乳白色泡沫，沿岸能闻到明显刺鼻气味。多位村民向 911爆料 反映，异常多出现在凌晨时段，天亮后逐渐消散。",
      },
      { type: "heading", text: "凌晨的白色泡沫" },
      {
        type: "paragraph",
        text: "记者连续两周在凌晨三点至五点蹲守，记录了泡沫出现与消退的时间规律。取样点分布在上游两公里至下游五公里之间，异常带大致集中在三处河道支流汇入口附近。",
      },
      {
        type: "image",
        url: "https://readdy.ai/api/search-image?query=Close%20up%20of%20murky%20river%20water%20with%20white%20foam%20at%20night%20under%20faint%20street%20light%2C%20dark%20charcoal%20tones%20with%20deep%20red%20reflection%2C%20cinematic%20editorial%20photography%2C%20high%20detail%2C%20stylized%20not%20photoreal%2C%20no%20text&width=1000&height=640&seq=911-news-1001b&orientation=landscape",
        caption: "凌晨四点，下游河面出现的乳白色泡沫（记者摄）",
      },
      { type: "heading", text: "监管为何慢了一步" },
      {
        type: "paragraph",
        text: "按照现行属地管理原则，交界河段由相邻三县分段负责。多位受访的基层工作人员表示，跨界河道的联合巡查机制存在衔接空档，异常往往在消散后才被记录。",
      },
      {
        type: "paragraph",
        text: "截至发稿，当地生态环境部门已对上游三处疑似排放点启动排查，并对河道断面加密监测。911爆料 将持续跟进监测结果与整改进展。",
      },
    ],
  },
  {
    id: "news-1002",
    title: "专项巡察通报：一批工程招标违规线索已移交处理",
    summary:
      "本轮专项巡察聚焦政府投资类项目，通报指出部分招标环节存在程序瑕疵，相关线索已按流程移交。",
    category: "politics",
    topics: [],
    source: "911爆料时政组",
    author: "时政组",
    publishedAt: "2026-10-13 20:05",
    image:
      "https://readdy.ai/api/search-image?query=Serious%20editorial%20news%20scene%20of%20a%20stately%20government%20building%20with%20tall%20columns%2C%20a%20sealed%20document%20folder%20in%20focus%2C%20dim%20charcoal%20lighting%20with%20subtle%20deep%20red%20accents%2C%20cinematic%20photography%2C%20high%20detail%2C%20stylized%20not%20photoreal%2C%20no%20text&width=1200&height=800&seq=911-news-1002&orientation=landscape",
    exclusive: false,
    isFocus: true,
    views: 96520,
    content: [
      {
        type: "paragraph",
        text: "本轮专项巡察聚焦政府投资类工程项目的招投标环节。通报显示，部分项目在资格预审、评标专家抽取与合同履约等节点存在程序瑕疵，相关线索已按流程移交有关部门。",
      },
      { type: "heading", text: "通报关注的三个节点" },
      {
        type: "paragraph",
        text: "一是资格预审文件的实质性审查不够充分；二是评标环节的信息留痕不完整；三是中标后的合同变更管理存在滞后。通报要求相关单位限期完成自查并提交整改报告。",
      },
      {
        type: "paragraph",
        text: "有长期参与工程审计的业内人士向记者表示，招标环节的问题往往不是单点漏洞，而是多环节衔接不畅累积的结果，需要从制度层面加以规范。",
      },
      { type: "heading", text: "整改与公开" },
      {
        type: "paragraph",
        text: "通报强调，整改情况将纳入下一轮巡察的重点内容。多地已开始公布整改清单，接受社会监督。",
      },
    ],
  },
  {
    id: "news-1003",
    title: "中小银行不良资产处置提速，风险化解进入关键窗口",
    summary:
      "多家区域性银行加快不良资产打包转让，业内人士称处置节奏与定价透明度成为市场关注焦点。",
    category: "economy",
    topics: ["t2"],
    source: "911爆料财经组",
    author: "财经组",
    publishedAt: "2026-10-14 09:40",
    image:
      "https://readdy.ai/api/search-image?query=Financial%20district%20glass%20skyscrapers%20at%20dusk%20with%20glowing%20windows%2C%20moody%20dark%20charcoal%20palette%20and%20faint%20deep%20red%20light%2C%20cinematic%20editorial%20photography%2C%20high%20detail%2C%20stylized%20not%20photoreal%2C%20no%20text&width=1200&height=800&seq=911-news-1003&orientation=landscape",
    exclusive: false,
    isFocus: true,
    views: 74210,
    content: [
      {
        type: "paragraph",
        text: "进入下半年，多家区域性银行明显加快了不良资产的处置节奏，围绕不良贷款打包转让、抵债资产变现等方式的动作较为集中。",
      },
      { type: "heading", text: "节奏与定价" },
      {
        type: "paragraph",
        text: "业内普遍认为，处置节奏加快有助于尽快释放风险敞口，但定价透明度与尽调充分性同样重要。部分受让方透露，对底层资产的实际情况仍需要更多交叉验证。",
      },
      {
        type: "paragraph",
        text: "受访分析师指出，未来一段时间，资产质量改善与拨备计提的平衡，将成为观察银行经营稳健性的关键指标。",
      },
    ],
  },
  {
    id: "news-1004",
    title: "独家｜物流园区“影子仓库”调查：违规存储链条浮出水面",
    summary:
      "一份内部盘点表牵出多层转租的仓储网络，货物归属在账面上反复“漂移”。记者实地探访园区深处。",
    category: "exclusive",
    topics: ["t2"],
    source: "911爆料独家",
    author: "独家调查组",
    publishedAt: "2026-10-14 07:15",
    image:
      "https://readdy.ai/api/search-image?query=Dim%20logistics%20warehouse%20interior%20with%20tall%20stacks%20of%20crates%20and%20deep%20shadows%2C%20narrow%20corridors%2C%20faint%20deep%20red%20safety%20light%2C%20dark%20charcoal%20tones%2C%20cinematic%20editorial%20photography%2C%20high%20detail%2C%20stylized%20not%20photoreal%2C%20no%20text&width=1200&height=800&seq=911-news-1004&orientation=landscape",
    exclusive: true,
    isFocus: true,
    views: 210960,
    content: [
      {
        type: "paragraph",
        text: "911爆料 独家获得的一份内部盘点表显示，某物流园区内存在多层转租形成的仓储网络，部分库位的实际货主与账面登记信息并不一致。",
      },
      { type: "heading", text: "账面上的“漂移”" },
      {
        type: "paragraph",
        text: "盘点表上，同一批货物在不同日期被登记在不同主体名下。熟悉仓储流程的人士解释，这种“漂移”常见于转租与代管交叉的场景，也给货物流向追溯带来了困难。",
      },
      {
        type: "image",
        url: "https://readdy.ai/api/search-image?query=Stack%20of%20shipping%20labels%20and%20clipboard%20forms%20on%20a%20metal%20table%20in%20a%20dim%20warehouse%2C%20deep%20red%20accent%20light%2C%20dark%20charcoal%20tones%2C%20cinematic%20editorial%20photography%2C%20high%20detail%2C%20stylized%20not%20photoreal%2C%20no%20text&width=1000&height=640&seq=911-news-1004b&orientation=landscape",
        caption: "园区内被反复登记的货签与盘点表（资料图）",
      },
      { type: "heading", text: "园区深处的白墙" },
      {
        type: "paragraph",
        text: "记者以洽谈仓储合作为名进入园区，发现部分区域以白墙分隔，标识模糊。园区管理方对转租情况回应称“正在核实”。",
      },
      {
        type: "paragraph",
        text: "截至发稿，相关主管部门表示已关注到相关线索，将依规开展核查。",
      },
    ],
  },
  {
    id: "news-1005",
    title: "老旧小区改造资金去向追踪：三笔款项仍未公开",
    summary:
      "居民关心的改造资金使用明细迟迟未见公示，记者梳理公开信息后发现三笔款项的去向仍不清晰。",
    category: "society",
    topics: ["t1"],
    source: "911爆料民生组",
    author: "民生组",
    publishedAt: "2026-10-12 18:30",
    image:
      "https://readdy.ai/api/search-image?query=Aging%20residential%20apartment%20blocks%20under%20renovation%20scaffolding%20at%20dusk%2C%20warm%20windows%20against%20dark%20charcoal%20tones%20with%20subtle%20deep%20red%20accent%2C%20cinematic%20editorial%20photography%2C%20high%20detail%2C%20stylized%20not%20photoreal%2C%20no%20text&width=1200&height=800&seq=911-news-1005&orientation=landscape",
    exclusive: false,
    isFocus: false,
    views: 58300,
    content: [
      {
        type: "paragraph",
        text: "该小区改造工程已于今年上半年完工，但部分居民反映，改造资金的使用明细迟迟没有完整公示。",
      },
      { type: "heading", text: "三笔待厘清的款项" },
      {
        type: "paragraph",
        text: "记者梳理公开信息发现，涉及管线迁改、绿化提升与外立面整治的三笔款项，其具体金额与执行主体在公示材料中表述不一。",
      },
      {
        type: "paragraph",
        text: "社区工作人员回应称，相关材料正在整理，将尽快补充公示。",
      },
    ],
  },
  {
    id: "news-1006",
    title: "预制菜供应链透明度调查：标签之外的隐忧",
    summary:
      "从原料到成品，一袋预制菜要经过多个环节。记者走访发现，部分环节的信息披露仍显不足。",
    category: "economy",
    topics: ["t4"],
    source: "911爆料财经组",
    author: "财经组",
    publishedAt: "2026-10-11 16:10",
    image:
      "https://readdy.ai/api/search-image?query=Food%20processing%20packaging%20line%20with%20sealed%20trays%20under%20cold%20industrial%20light%2C%20dark%20charcoal%20tones%20with%20deep%20red%20accent%2C%20cinematic%20editorial%20photography%2C%20high%20detail%2C%20stylized%20not%20photoreal%2C%20no%20text&width=1200&height=800&seq=911-news-1006&orientation=landscape",
    exclusive: false,
    isFocus: false,
    views: 47120,
    content: [
      {
        type: "paragraph",
        text: "预制菜从原料采购到成品出厂，通常要经过预处理、加工、速冻与包装等多个环节，而消费者能看到的往往只是包装上的一行配料表。",
      },
      { type: "heading", text: "标签能说明多少" },
      {
        type: "paragraph",
        text: "受访的食品行业从业者表示，标签信息是合规底线，但供应链透明度还涉及原料溯源与储运温度记录等更多细节。",
      },
      {
        type: "paragraph",
        text: "监管方面近年持续加大对预制菜生产环节的抽检力度，相关标准也在逐步完善。",
      },
    ],
  },
  {
    id: "news-1007",
    title: "暴雨预警升级：多地启动应急响应，交通出行提示",
    summary:
      "气象部门升级暴雨预警，多地启动应急响应。记者汇总实时路况与出行提示，提醒公众注意安全。",
    category: "breaking",
    topics: ["t3"],
    source: "911爆料突发组",
    author: "突发组",
    publishedAt: "2026-10-14 06:05",
    image:
      "https://readdy.ai/api/search-image?query=Heavy%20storm%20rain%20over%20a%20city%20road%20at%20dusk%20with%20traffic%20lights%20glow%20and%20puddle%20reflections%2C%20dark%20charcoal%20tones%20with%20deep%20red%20accents%2C%20cinematic%20editorial%20photography%2C%20high%20detail%2C%20stylized%20not%20photoreal%2C%20no%20text&width=1200&height=800&seq=911-news-1007&orientation=landscape",
    exclusive: false,
    isFocus: false,
    views: 88310,
    content: [
      {
        type: "paragraph",
        text: "气象部门今日清晨升级暴雨预警信号，多地同步启动应急响应，部分路段出现积水。",
      },
      { type: "heading", text: "重点路况" },
      {
        type: "paragraph",
        text: "截至上午，若干下穿隧道与低洼路口实施临时管控。公共交通方面，部分线路采取绕行或区间运营措施。",
      },
      {
        type: "paragraph",
        text: "提醒公众减少非必要外出，避开积水路段与广告牌、临时构筑物附近，注意出行安全。",
      },
    ],
  },
  {
    id: "news-1008",
    title: "环保督察“回头看”：重点行业整改清单公布",
    summary:
      "本轮“回头看”聚焦前期问题的整改落实，多个重点行业的整改清单已向社会公布。",
    category: "politics",
    topics: ["t4"],
    source: "911爆料时政组",
    author: "时政组",
    publishedAt: "2026-10-10 14:20",
    image:
      "https://readdy.ai/api/search-image?query=Industrial%20chimneys%20and%20pipes%20under%20overcast%20sky%20with%20faint%20steam%2C%20dark%20charcoal%20palette%20with%20subtle%20deep%20red%20ambient%20light%2C%20cinematic%20editorial%20photography%2C%20high%20detail%2C%20stylized%20not%20photoreal%2C%20no%20text&width=1200&height=800&seq=911-news-1008&orientation=landscape",
    exclusive: false,
    isFocus: false,
    views: 39980,
    content: [
      {
        type: "paragraph",
        text: "本轮环保督察“回头看”重点检视前期发现问题的整改落实情况，多个重点行业的整改清单已向社会公布。",
      },
      { type: "heading", text: "清单上的变化" },
      {
        type: "paragraph",
        text: "与前期相比，本轮清单在整改措施与完成时限上更加具体，部分事项还明确了责任主体与验收标准。",
      },
      {
        type: "paragraph",
        text: "业内人士认为，公开清单有助于形成持续监督，但整改的实际效果仍需通过后续跟踪来验证。",
      },
    ],
  },
  {
    id: "news-1009",
    title: "独家资料｜数据买卖灰色链条：一条被忽视的通道",
    summary:
      "911爆料 独家获得的资料显示，部分数据交易通过多层转手完成，来源与用途难以追溯。",
    category: "exclusive",
    topics: ["t2"],
    source: "911爆料独家",
    author: "独家调查组",
    publishedAt: "2026-10-09 21:00",
    image:
      "https://readdy.ai/api/search-image?query=Dark%20server%20room%20with%20tangled%20cables%20and%20monitor%20glow%20in%20deep%20red%20ambient%20light%2C%20charcoal%20tones%2C%20cinematic%20editorial%20photography%2C%20high%20detail%2C%20strong%20contrast%2C%20stylized%20not%20photoreal%2C%20no%20text&width=1200&height=800&seq=911-news-1009&orientation=landscape",
    exclusive: true,
    isFocus: false,
    views: 156740,
    content: [
      {
        type: "paragraph",
        text: "911爆料 独家获得的一批交易记录显示，部分数据交易通过多层转手完成，买卖双方并不直接接触。",
      },
      { type: "heading", text: "层层转手的通道" },
      {
        type: "paragraph",
        text: "记录中，同一批数据在不同环节被反复打包与拆分，原始来源与最终用途都难以追溯。",
      },
      { type: "heading", text: "被忽视的环节" },
      {
        type: "paragraph",
        text: "受访的信息安全从业者提醒，数据流向的合规审查往往集中在采集端，而对流转与二次转售环节的关注相对不足。",
      },
    ],
  },
  {
    id: "news-1010",
    title: "社区养老床位调查：一床难求背后的资源错配",
    summary:
      "一边是排队等待的入住申请，一边是部分床位长期闲置。记者走访多个社区，试图理解这道算术题。",
    category: "society",
    topics: ["t1"],
    source: "911爆料民生组",
    author: "民生组",
    publishedAt: "2026-10-08 10:45",
    image:
      "https://readdy.ai/api/search-image?query=Modest%20community%20elderly%20care%20room%20with%20empty%20beds%20and%20soft%20window%20light%2C%20warm%20charcoal%20tones%20with%20subtle%20deep%20red%20accent%2C%20cinematic%20editorial%20photography%2C%20high%20detail%2C%20stylized%20not%20photoreal%2C%20no%20text&width=1200&height=800&seq=911-news-1010&orientation=landscape",
    exclusive: false,
    isFocus: false,
    views: 33210,
    content: [
      {
        type: "paragraph",
        text: "近年来，社区养老服务需求快速增长，但“一床难求”与“床位闲置”的现象同时存在。",
      },
      { type: "heading", text: "需求与供给的错位" },
      {
        type: "paragraph",
        text: "记者走访发现，位置便利、护理力量充足的机构排队较长，而部分偏远机构的床位利用率偏低。",
      },
      {
        type: "paragraph",
        text: "有研究者建议，通过区域统筹与差异化定价，让有限的床位资源更好地匹配实际需求。",
      },
    ],
  },
  {
    id: "news-1011",
    title: "直播带货退货率走高，平台规则迎来新一轮调整",
    summary:
      "部分品类退货率明显上升，平台陆续调整流量与售后规则，商家与消费者的博弈进入新阶段。",
    category: "economy",
    topics: ["t2"],
    source: "911爆料财经组",
    author: "财经组",
    publishedAt: "2026-10-07 15:30",
    image:
      "https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20with%20ring%20light%20camera%20and%20blurred%20product%20shelf%2C%20dark%20charcoal%20tones%20with%20deep%20red%20accent%20glow%2C%20cinematic%20editorial%20photography%2C%20high%20detail%2C%20stylized%20not%20photoreal%2C%20no%20text&width=1200&height=800&seq=911-news-1011&orientation=landscape",
    exclusive: false,
    isFocus: false,
    views: 41880,
    content: [
      {
        type: "paragraph",
        text: "受多重因素影响，部分品类的直播退货率出现明显上升，围绕售后与流量的规则也随之调整。",
      },
      { type: "heading", text: "规则调整了什么" },
      {
        type: "paragraph",
        text: "平台在流量分配、售后响应时限与虚假宣传治理等方面陆续更新规则，商家需要相应调整运营策略。",
      },
      {
        type: "paragraph",
        text: "消费者权益保护方面的专家表示，规则调整的关键在于让信息更透明，让责任更清晰。",
      },
    ],
  },
  {
    id: "news-1012",
    title: "突发：某高速多车追尾，救援力量已抵达现场",
    summary:
      "今日上午某高速路段发生多车追尾事故，救援力量已抵达现场处置，相关路段短暂管控。",
    category: "breaking",
    topics: ["t3"],
    source: "911爆料突发组",
    author: "突发组",
    publishedAt: "2026-10-14 11:25",
    image:
      "https://readdy.ai/api/search-image?query=Wet%20highway%20at%20dawn%20with%20emergency%20vehicle%20light%20glow%20and%20mist%2C%20stopped%20cars%20in%20a%20row%2C%20dark%20charcoal%20tones%20with%20deep%20red%20reflections%2C%20cinematic%20editorial%20photography%2C%20high%20detail%2C%20stylized%20not%20photoreal%2C%20no%20text&width=1200&height=800&seq=911-news-1012&orientation=landscape",
    exclusive: false,
    isFocus: false,
    views: 102350,
    content: [
      {
        type: "paragraph",
        text: "今日上午，某高速路段因突发团雾发生多车追尾事故，救援力量第一时间抵达现场。",
      },
      { type: "heading", text: "现场处置" },
      {
        type: "paragraph",
        text: "相关路段实施短暂管控，救援与事故处理同步进行。气象部门提示，清晨与夜间需警惕团雾对行车视线的影响。",
      },
      {
        type: "paragraph",
        text: "具体原因与后续情况以有关部门通报为准，911爆料 将持续关注。",
      },
    ],
  },
  {
    id: "news-1013",
    title: "农村饮水安全回访：两处集中供水工程仍未通水",
    summary:
      "承诺年内通水的两处集中供水工程仍未投入使用，部分村民依旧依赖自备井临时取水。",
    category: "society",
    topics: ["t1", "t4"],
    source: "911爆料民生组",
    author: "民生组",
    publishedAt: "2026-10-06 09:15",
    image:
      "https://readdy.ai/api/search-image?query=Rural%20water%20pipeline%20and%20valve%20along%20an%20open%20field%20under%20overcast%20sky%2C%20dark%20charcoal%20tones%20with%20subtle%20deep%20red%20accent%2C%20cinematic%20editorial%20photography%2C%20high%20detail%2C%20stylized%20not%20photoreal%2C%20no%20text&width=1200&height=800&seq=911-news-1013&orientation=landscape",
    exclusive: false,
    isFocus: false,
    views: 27640,
    content: [
      {
        type: "paragraph",
        text: "今年年初，当地曾承诺年内完成两处集中供水工程并实现通水，但 911爆料 回访发现，工程目前仍未投入使用。",
      },
      { type: "heading", text: "卡在哪一步" },
      {
        type: "paragraph",
        text: "受访施工人员透露，管网接入与验收环节存在衔接问题。部分村民仍依赖自备井临时取水。",
      },
      {
        type: "paragraph",
        text: "相关部门回应称，正在协调推进验收工作，力争尽快实现通水。",
      },
    ],
  },
  {
    id: "news-1014",
    title: "独家追踪｜跨境电信网络诈骗线索移交，受害者讲述经历",
    summary:
      "一批跨境电信网络诈骗相关线索完成移交。911爆料 独家对话多位受害者，还原被骗经过。",
    category: "exclusive",
    topics: ["t3"],
    source: "911爆料独家",
    author: "独家调查组",
    publishedAt: "2026-10-05 20:40",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20call%20center%20desks%20with%20phones%20and%20screens%20in%20a%20dim%20room%2C%20deep%20red%20ambient%20glow%2C%20dark%20charcoal%20tones%2C%20cinematic%20editorial%20photography%2C%20high%20detail%2C%20stylized%20not%20photoreal%2C%20no%20text&width=1200&height=800&seq=911-news-1014&orientation=landscape",
    exclusive: true,
    isFocus: false,
    views: 189220,
    content: [
      {
        type: "paragraph",
        text: "近日，一批跨境电信网络诈骗相关线索完成移交。911爆料 独家对话多位受害者，试图还原被骗经过。",
      },
      { type: "heading", text: "一步步落入圈套" },
      {
        type: "paragraph",
        text: "受害者描述，对方往往先以小额的“收益”建立信任，再逐步引导加大投入，最终以各种理由拒绝提现。",
      },
      { type: "heading", text: "如何防范" },
      {
        type: "paragraph",
        text: "反诈工作人员提示，凡涉及“稳赚不赔”“内部渠道”的承诺，都应当高度警惕，及时通过官方渠道核实。",
      },
    ],
  },
];